import { call, put, takeEvery } from "redux-saga/effects";
import { ERROR_MESSAGE } from "common/constants";
import { HomeActionTypes } from "./types";
import {
  fetchAppList, fetchSwitchCompany,
  fetchPersonalCertInfo,
  fetchPersonalCompanyList
} from "./actions";
import fetchApi from "../../utils/fetchApi";

/**
 * 执行获取应用列表
 *
 */
function* handleFetchAppList() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "permissionServer/user/center/app/list");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      //根据产品要求，微知端不显示smarthr
      const filterApps = (res.data.records || []).filter((record: any) => ["smarthr","驻场通"].indexOf(record.appName.toLowerCase()) === -1 );

      // yield put(fetchAppList.success(res.data.records || []));
      yield put(fetchAppList.success(filterApps || []));
    } else {
      yield put(fetchAppList.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchAppList.failure(msg));
  }
}

/*
* 切换公司
*
* */
function* handleFetchSwitchCompany(
  action: ReturnType<typeof fetchSwitchCompany.request>
) {
  const {params, success} = action.payload
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", `home-server/auth/chooseCompany/${params.cid}`);

    // 请求结果调度
    if (res.result === 0) {
      yield put(fetchSwitchCompany.success());
      success()
    } else {
      yield put(fetchSwitchCompany.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchSwitchCompany.failure(msg));
  }
}

/*
* 获取用户认证信息
*
*
* */
function* handleFetchPersonalCertInfo() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "home-server/auth/userCertCompany");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      yield put(fetchPersonalCertInfo.success(res.data.extra));
    } else {
      yield put(fetchPersonalCertInfo.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchPersonalCertInfo.failure(msg));
  }
}

/*
* 获取登录用户公司列表
* */
function* handleFetchPersonalCompanyList() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "home-server/company/list");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      yield put(fetchPersonalCompanyList.success(res.data.records));
    } else {
      yield put(fetchPersonalCompanyList.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchPersonalCompanyList.failure(msg));
  }
}


// 监控，根据指定action类型，调用saga方法
function* homeSaga() {
  yield takeEvery(HomeActionTypes.FETCH_APP_LIST, handleFetchAppList);
  yield takeEvery(HomeActionTypes.FETCH_SWITCH_COMPANY, handleFetchSwitchCompany);
  yield takeEvery(HomeActionTypes.FETCH_PERSONAL_CERT_INFO, handleFetchPersonalCertInfo);
  yield takeEvery(HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST, handleFetchPersonalCompanyList);

}

export default homeSaga;
